import React from "react";
import { useGoogleLogin } from "@react-oauth/google";
import styled from "styled-components";
import { useNavigate } from "react-router";
import { setTokenCookie } from "../../TokenCookie";
import { redirectAfterAuthOrDefault } from "../../services/Utils";
const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;
const Button = styled.button`
  all: unset;
  box-sizing: border-box;
  padding: 0.8rem 1.6rem;
  height: 4.8rem;
  width: 100%;
  display: flex;
  align-items: center;
  .icon {
    flex-shrink: 0;
  }
  border-radius: 8px;
  font-size: 1.4rem;
  gap: 0.8rem;
  justify-content: center;
  cursor: pointer;
  transition: all 200ms ease-in-out;
  font-weight: 600;
  color: #181818;
  background-color: #fff;
  border: 1px solid rgba(1, 1, 1, 0.2);
  &:hover {
    background-color: #f7f7f7;
    border-color: rgba(1, 1, 1, 0.3);
  }

  position: relative;
`;

const GoogleIcon = () => (
  <svg className="icon" width="1.8rem" height="1.8rem" viewBox="0 0 18 18">
    <path
      fill="#4285F4"
      d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2581h2.9087c1.7018-1.5668 2.6836-3.874 2.6836-6.615z"
    />
    <path
      fill="#34A853"
      d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.5401-1.8368.8586-3.0477.8586-2.344 0-4.3282-1.5831-5.036-3.7104H.9573v2.3318C2.4382 15.9832 5.4818 18 9 18z"
    />
    <path
      fill="#FBBC05"
      d="M3.964 10.71c-.18-.5401-.2822-1.1168-.2822-1.71s.1023-1.1699.2822-1.71V4.9582H.9573A8.9965 8.9965 0 000 9c0 1.4523.3477 2.8268.9573 4.0418L3.964 10.71z"
    />
    <path
      fill="#EA4335"
      d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.964 7.29C4.6718 5.1627 6.656 3.5795 9 3.5795z"
    />
  </svg>
);

//COMPONENT VERIFIED
export default function GoogleLoginButton({
  setLogging,
  setErrorMessage,
  action,
  buttonTxt,
  phone,
  canProceedWithGoogleRegister,
}) {
  const navigate = useNavigate();
  const googleLogin = useGoogleLogin({
    flow: "auth-code",
    onSuccess: async (access) => {
      try {
        const body = {
          code: access.code,
          scope: access.scope,
          ...(action === "register" ? { phone } : {}),
        };

        const url = `${BASE_URL}auth/google/${action}`;
        const res = await fetch(url, {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            "Content-Type": "application/json",
          },
        });

        const bodyTxt = await res.text();
        if (res.ok) {
          setTokenCookie(bodyTxt);
          if (action === "register") {
            redirectAfterAuthOrDefault(
              navigate,
              "/encartes?autoCreateEncarte=true",
            );
          } else {
            redirectAfterAuthOrDefault(navigate);
          }
          return;
        } else if (res.status == 409) {
          setErrorMessage(
            "Esse email já está sendo utilizado. Tente fazer login.",
          );
        } else if (res.status == 404) {
          setErrorMessage(
            "Não existe nenhuma conta vinculada a esse email. Tente criar uma nova conta",
          );
        } else if (res.status == 403) {
          setErrorMessage(
            "Você precisa entrar em sua conta com email e senha. Login com Google não é permitido. Se tiver com dúvida, entre em contato com o suporte.",
          );
        } else if (res.status == 401) {
          setErrorMessage(
            "Não foi possível validar sua conta Google. Tente novamente.",
          );
        } else {
          setErrorMessage("Não foi possível continuar. Tente novamente.");
        }
        setLogging(false);
      } catch (err) {
        setErrorMessage("Sem conexão. Tente novamente.");
        setLogging(false);
      }
    },
    onError: (errorResponse) => {
      setLogging(false);
    },
    onNonOAuthError: (e) => {
      setLogging(false);
    },
  });

  return (
    <Button
      onClick={() => {
        const isGoogleRegister = action === "register";
        const hasRegisterPreCheck =
          typeof canProceedWithGoogleRegister === "function";
        const shouldBlockGoogleRegister =
          isGoogleRegister &&
          hasRegisterPreCheck &&
          canProceedWithGoogleRegister() === false;

        if (shouldBlockGoogleRegister) {
          return;
        }

        setLogging(true);
        try {
          googleLogin();
        } catch (err) {}
      }}
    >
      <GoogleIcon />
      <span>{buttonTxt}</span>
    </Button>
  );
}
